module.exports = __webpack_public_path__ + "static/media/myh.8bc456eb.jpg";